/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1year,
} from "../../funcs/metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1year.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1yearRequest$inboundSchema
    .optional(),
};

export const tool$metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1year:
  ToolDefinition<typeof args> = {
    name:
      "metrics-governance-not-dissolving-neurons-staked-e8s-1year",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await metricsGetApiV3MetricsGovernanceNotDissolvingNeuronsStakedMaturityE8sEquivalent1year(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
